export default [
  {
    name: 'Test Demo',
    url: 'https://test-demo.app.tomhogue.io',
  },
];
